import React, { useContext, useEffect } from 'react';
import StudyCard from '../studiesPage/studyPage';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/system';
import ActivityPageForUser from '../../pages/activityPageForUser/activityPageForUser'
import ActiveStudyCardForUser from '../activeStudyCardForUser/activeStudyCardForUser';
import ActiveStudyDocumentForUser from '../activeStudyDocumentForUser/activeStudyDocumentForUser';
import ActiveStudyAccepted from '../activeStudyAcceptedForm/activeStudyAcceptedForm';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import UserContext from '../../Context/User/userContext';

const StyledTab = styled(Tab)({
    fontSize: '1.1rem',
    fontWeight: '600', // Increased label size
    color: '#008B8B', // Default color
    '&:hover': {
        color: '#169a8f', // Change color to yellow on hover
    },
    '&.Mui-selected': {
        color: '#169a8f', // Change color to blue for the active tab
    },
    paddingLeft: '10px',
    marginRight: '50px',// Add spacing between tabs
    fontFamily: 'nunito'

});


const StyledTabList = styled(TabList)({
    background: '#E0F2F1', /* Fallback for old browsers */
    background: '-webkit-linear-gradient(to left, #B2DFDB, #E0F2F1)', /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to left, #B2DFDB, #E0F2F1)', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    backgroundColor: '#ffffff', // Background color
    color: '#169a8f',
    display: 'flex', // Flexbox display
    justifyContent: 'around', // Centering tabs
    alignItems: 'center' // Aligning items vertically
});


function ActiveStudyFormUser({ setShowSpinner }) {
    const [data, setData] = React.useState([]);
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { id } = useParams();
    //Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    const { user, setUser } = useContext(UserContext);
    const getData = () => {
        axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/specific`,
            {
                _id: id
            }, {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                const response = res.data.data
                setData(response);
            })
            .catch(error => {
                console.log(error.response?.data?.message);
            })
            .finally(() => {
                setShowSpinner(false);
            })
    }

    useEffect(() => {
        if (user) {
            getData()
        }
    }, [user])
    console.log(data[0])

    return (
        <div className='p-4'>
            <div className='d-flex align-items-center'>
                <div>
                    <h4 style={{color:'rgb(23 131 131)'}}>Study Title : {data && data[0] && data[0]?.adminStudy?.title}/{data && data[0] && data[0]?.adminStudy?.studyCode}</h4>
                </div>
                <div>
                    <h6 style={{ color: 'red', marginLeft: '5px' }}>({data && data[0] && data[0]?.adminStudy?.status})</h6>
                </div>
            </div>
            <div className='mt-3'>
                <ActiveStudyCardForUser setShowSpinner={setShowSpinner} id={id} />
            </div>
            <div className='mt-3'>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <StyledTabList onChange={handleChange} aria-label="lab API tabs example">
                                <StyledTab label="Study" value="1" />
                                <StyledTab label="Documents" value="2" />
                                <StyledTab label="Activity" value="3" />
                            </StyledTabList>
                        </Box>
                        <TabPanel value="1"><ActiveStudyAccepted data={data} /></TabPanel>
                        <TabPanel value="2"><ActiveStudyDocumentForUser setShowSpinner={setShowSpinner} studyData={data} /></TabPanel>
                        <TabPanel value="3"><ActivityPageForUser setShowSpinner={setShowSpinner} data={data} /></TabPanel>
                    </TabContext>
                </Box>
            </div>
        </div>
    );
}

export default ActiveStudyFormUser;
